// ported from the app repo (src/js/wisemetering/utils.js), which is where the
// WiseMetering global lives — this app has no such global. The messages come from
// the app's ui.passwords.requirements locale keys; this app has no i18next.
export default (password, passwordConfirmation) => ({
    length: { met: password.length >= 16 && password.length <= 32, message: '16-32 Characters' },
    uppercase: { met: /[A-Z]/.test(password), message: '1 Uppercase Letter' },
    lowercase: { met: /[a-z]/.test(password), message: '1 Lowercase Letter' },
    number: { met: /\d/.test(password), message: '1 Number' },
    specialChar: { met: /[!\\#$%&()*+\-=?@^_~]/.test(password), message: '1 Special Character ( !\\#$%&()*+-=?@^_~ )' },
    passwordConfirmation: { met: password === passwordConfirmation, message: 'Password and confirmation must match' }
});
